export default "__VITE_ASSET__pG8oKvRv__"